import React from "react"
import styled from "styled-components"
import * as PhoneNumberTools from "~/utilities/phoneNumber"
import TRACKING from "~/services/tracking"
import PhoneIcon from "../../public/static/images/svg/phoneIcon.svg"

const PhoneContainer = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.primary};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  margin-left: 15px;
`
const PhoneImage = styled.img`
  margin: ${props => props.iconMargin ? props.iconMargin : "0 10px 0 0"};
`

const PhoneText = styled.span`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  ${props => props.hideNumber ? `
    display: none;
  ` : null}
`

const HeaderSupportPhoneNumber = ({phoneNumber, hideNumber, icon, iconMargin}) => {

  const displayPhoneNumber = PhoneNumberTools.AsYouTypeFormatter(phoneNumber)
  return (
    <PhoneContainer
      href={`tel:+1${phoneNumber}`}
      onClick={TRACKING.traffic.clickedPhoneNumber}
    >
      <PhoneText>
        <PhoneImage
          src={icon || PhoneIcon}
          alt="Call Us"
          iconMargin={iconMargin}
        />
      </PhoneText>
      <PhoneText hideNumber={hideNumber}>{displayPhoneNumber}</PhoneText>
    </PhoneContainer> 
  )
}

export default HeaderSupportPhoneNumber
